<div class="ks-card">
  <header class="ks-card-header title-card">
    <div class="ks-card-header__title">
      <div class="ks-card-title">
        <h1 class="ks-h1 ks-mb-0">{{ 'MESSAGE.INPUT.INFO' | translate }}</h1>
      </div>
    </div>
    <div class="ks-card-header__tools">
      <button
        type="button"
        ktTooltip="Close"
        class="ks-btn-xs ks-btn-icon-round ks-btn-flat-neutral"
        (click)="close($event)"
      >
        <span inlineSVG="assets/icons/Close.svg"></span>
      </button>
    </div>
  </header>
  <main class="ks-card-body">
    <!-- <div class="card-body-progress">
      <mat-spinner [diameter]="20"></mat-spinner>
  </div> -->
    <div class="col">
      <div class="row">
        <dt class="title">{{ 'MESSAGE.INPUT.SENDER' | translate }}:</dt>
        <dd class="info">{{ message.sender_name }}</dd>
      </div>
      <div class="row">
        <dt class="title">{{ 'MESSAGE.INPUT.TEXT' | translate }}:</dt>
        <dd class="info">{{ message.body }}</dd>
      </div>
      <div class="row" *ngIf="loadingTags || (!loadingTags && messageTags.length)">
        <dt class="title">{{ 'MESSAGE.INPUT.TAG' | translate }}:</dt>
        <div class="info">
          <div *ngIf="loadingTags">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
          <div class="h-0" *ngIf="!loadingTags">
            <kt-tags [readOnly]="true" [readOnlyValue]="messageTags"></kt-tags>
          </div>
        </div>
      </div>
      <div class="row">
        <dt class="title">{{ 'MESSAGE.INPUT.FILE' | translate }}:</dt>
        <dd class=""><kt-attachments-list [data]="attachmentData"></kt-attachments-list></dd>
      </div>
    </div>
  </main>
</div>
